module.exports = __webpack_public_path__ + "static/pic04-008bc25de3c0e35f035ebccf5ac21d4d.jpg";